import Vue from 'vue';
import { router, store } from './bootstrap';
import App from './components/App';

var __svg__ = { path: './../assets/svg/**/*.svg', name: 'static/svg-sprite/[hash]svg-symbols.svg' };

require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

// Vue.config.debug = false;
// Vue.config.devtools = false;

new Vue({

    el: '#app',
    render: h => h(App),
    store: store,
    router: router,

    data:
    {
        hasTouch: false
    },

    mounted()
    {
        moment().locale(Vue.config.lang);

        window.addEventListener('load', this.getViewportSize);
        window.addEventListener('resize', this.getViewportSize);
        window.addEventListener('touchstart', this.setHasTouch);

        // the following snippet can be used when user returns to browser tab
        // document.addEventListener('visibilitychange', function()
        // {
        //     if (document.visibilityState == 'visible') { }
        // });
    },

    beforeDestroy()
    {
        window.removeEventListener('load', this.getViewportSize);
        window.removeEventListener('resize', this.getViewportSize);
    },

    methods:
    {
        setHasTouch()
        {
            this.hasTouch = true;

            // remove event listener once fired, otherwise it'll kill scrolling performance
            window.removeEventListener('touchstart', this.setHasTouch);
        },

        // sets viewport property based on viewport width
        getViewportSize()
        {
            this.$store.dispatch('layout/setViewport');
            this.$store.dispatch('layout/setMainContentHeight');
        }
    },

    components: { App }

});



// WEBPACK FOOTER //
// ./src/js/main.js